import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";

interface Unit {
  x: number;
  y: number;
  hp: number;
  alive?: boolean;
  // Waypoints still to be walked, [x, y] each, oldest first. Only present for
  // units following a queued path.
  route?: number[][];
  status: "idle" | "loading" | "failed";
  last: {
    x: number;
    y: number;
    status: "idle" | "loading" | "failed";
  };
}

interface Player {
  units: Record<string, Unit>;
}

type Players = Record<string, Player>;

var initialState: Players = {
  "0": {
    units: {
      "0": {
        x: 100,
        y: 100,
        hp: 100,
        status: "idle",
        last: {
          x: 100,
          y: 100,
          status: "idle",
        },
      },
      "1": {
        x: 200,
        y: 200,
        hp: 100,
        status: "idle",
        last: {
          x: 100,
          y: 100,
          status: "idle",
        },
      },
    },
  },
  "1": {
    units: {
      "0": {
        x: 400,
        y: 400,
        hp: 100,
        status: "idle",
        last: {
          x: 100,
          y: 100,
          status: "idle",
        },
      },
      "1": {
        x: 300,
        y: 300,
        hp: 100,
        status: "idle",
        last: {
          x: 100,
          y: 100,
          status: "idle",
        },
      },
    },
  },
};

export const gameSlice = createSlice({
  name: "game",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    /*updatePlayer: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state[action.payload.id].x = action.payload.x;
      state[action.payload.id].y = action.payload.y;
    }, */
    updatePlayers: (state, action) => {
      const playersData: {
        playerId: {
          units: {
            unitId: {
              x: string;
              y: string;
              hp: string;
              alive: boolean;
              route: number[][];
            };
          };
        };
      } = action.payload;
      for (const [playerId, unitsDict] of Object.entries(playersData)) {
        for (const [unitId, position] of Object.entries(unitsDict.units)) {
          state[playerId].units[unitId].last = {
            x: state[playerId].units[unitId].x,
            y: state[playerId].units[unitId].y,
            status: state[playerId].units[unitId].status,
          };
          state[playerId].units[unitId].x = Number(position.x);
          state[playerId].units[unitId].y = Number(position.y);
          // hp only arrives when it changed, so keep the old value otherwise
          if (position.hp !== undefined) {
            state[playerId].units[unitId].hp = Number(position.hp);
          }
          if (position.alive !== undefined) {
            state[playerId].units[unitId].alive = Boolean(position.alive);
          }
          // Like hp, the route is only sent while it exists plus once when it
          // empties — an absent route means unchanged, not gone.
          if (position.route !== undefined) {
            state[playerId].units[unitId].route = position.route;
          }
        }
      }
    },
  },
});

export const { updatePlayers } = gameSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectPlayers = (state: RootState) => state.players;

/* // We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const incrementIfOdd =
  (amount: number): AppThunk =>
  (dispatch, getState) => {
    const currentValue = selectPlayer(getState());
    if (currentValue % 2 === 1) {
      dispatch(incrementByAmount(amount));
    }
  }; */

export default gameSlice.reducer;
